module.exports = "/packs/images/pages/venues/library_desktop~1af2b0da5ea9413575504a5f434353ef.jpg";